import { C, t } from '../../Dashboard/components/dashboardConstants';
import ArchiveSearchBar from './ArchiveSearchBar';
import ArchiveAuditionCard from './ArchiveAuditionCard';

export default function ArchiveBoardDetail({ board, auditions, boards = [], onBack, onRemove, onMove, onOpen }) {
  return (
    <div style={{ padding: '20px 40px 80px' }}>
      {/* 뒤로 가기 */}
      <button onClick={onBack} style={{
        display: 'flex', alignItems: 'center', gap: '6px',
        background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginBottom: '32px',
      }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M19 12H5M5 12l7 7M5 12l7-7" stroke={C.sub} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        <span style={t('14px', 400, C.sub)}>뒤로 가기</span>
      </button>

      {/* 제목 */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '30px' }}>
        <h1 style={{ ...t('36px', 600, C.bk), margin: 0 }}>{board.name}</h1>
        <span style={t('16px', 400, C.sub)}>총 {board.count}개의 공고을 저장했습니다.</span>
      </div>

      <ArchiveSearchBar />

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px' }}>
        {auditions.map(item => (
          <ArchiveAuditionCard
            key={item.id}
            item={item}
            boards={boards}
            currentBoardId={board?.id}
            onRemove={onRemove}
            onMove={onMove}
            onOpen={onOpen}
          />
        ))}
      </div>
    </div>
  );
}
